"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// THIS FILE IS GENERATED
exports.version = {
    rmf_internal_msgs: '0c237e1758872917661879975d7dc0acf5fa518c',
    rmf_building_map_msgs: '1.2.0',
    rmf_server: 'bee64843943df02ddbea44659343a5f9ba2c9e64',
};
